import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import TagManager from "react-gtm-module";

import './i18n';

const tagManagerArgs = {
    gtmId: 'GTM-MM7CGLF'
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
    <Suspense fallback={(<div>Loading...</div>)}>
        <App />
    </Suspense>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
